import { ArrowBackIos } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { t } from 'i18next';

/**
 * `BackButton` is supposed to reimplement the browser's back button behavior,
 * therefore neither `onClick` nor `href` can be customized.
 */
type Props = Omit<ButtonProps, 'onClick' | 'href'>;

const overridableDefaults: Props = {
  variant: 'contained',
  startIcon: <ArrowBackIos style={{ fontSize: '0.875rem' }} />,
  disableElevation: true,
  sx: {
    backgroundColor: 'grey.200',
    textTransform: 'uppercase',
    alignSelf: 'flex-start',
    color: 'text.secondary',
    '&:hover': {
      backgroundColor: 'grey.300',
    },
  },
};

export const BackButton = (props: Props) => {
  const buttonProps = deepmerge<ButtonProps>(overridableDefaults, props);

  return (
    <Button {...buttonProps} onClick={() => history.back()} data-role="back-button">
      {t('back')}
    </Button>
  );
};
